export var userData = {
  languageRegion: {},
  profileInfo: {},
  addressInfo: [],
  userImg: '',
  staticSource: {
    phoneTypeList: [{
      name: "Custom",
      value: "custom"
    }, {
      name: "Mobile Phone",
      value: "mobile"
    }, {
      name: "Office Phone",
      value: "office"
    }, {
      name: "Business Phone",
      value: "business"
    }, {
      name: "Home Phone",
      value: "home"
    }, {
      name: "Fax",
      value: "fax"
    }]
  }
};
export var preData = {
  languageRegion: null,
  profileInfo: null,
  addressInfo: null
};
export var finalData = {
  languageRegion: null,
  profileInfo: null,
  addressInfo: null
};